// extracted by mini-css-extract-plugin
export default {"form":"QuickStartWizard_form__sTWuV"};